export const suggestionImgMap = {
    example_suggestion_homepage: '/img/mesh-bg/1.png',
    example_suggestion_product_or_service: '/img/mesh-bg/2.png',
    example_suggestion_pricing_page: '/img/mesh-bg/3.png',
    example_suggestion_about_us: '/img/mesh-bg/4.png',
    example_suggestion_landing_pages: '/img/mesh-bg/5.png',
};
